import theme from '@styles/theme';
export default {
  instructionListItem: {
    height: 'auto',
    width: '100%',
    borderTop: `1px solid ${theme.rawColors.lightGrey700}`,
    ul: {
      paddingLeft: '16px'
    },
    a: {
      textDecoration: 'underline'
    }
  },
  headerContainer: {
    display: 'flex',
    margin: ['20px 0', '20px 0', '24px 0', '24px 0', '27px 0'],
    alignItems: 'space-between',
    h3: {
      fontSize: theme.fontSizes.h3
    },
    'h4::first-letter': {
      textTransform: 'uppercase'
    },
    ':hover': {
      cursor: 'pointer'
    }
  },
  addButton: {
    marginRight: ['11px', '11px', '11px', '11px', '13px'],
    '.button-children-wrapper': {
      justifyContent: 'space-between',
      width: '100%',
      textAlign: 'left'
    }
  },
  productDescriptionItemContent: {
    margin: 'auto',
    ul: {
      padding: '0 16px 24px'
    }
  },
  productShowMoreContainer: {
    height: 'auto',
    width: '100%',
    position: 'absolute',
    zIndex: theme.zIndex.documentHigh,
    bottom: '0',
    left: '0',
    textAlign: 'center'
  },
  productShowMoreButton: {
    color: theme.rawColors.darkGrey700,
    cursor: 'pointer',
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%'
  }
};